import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import UserService from "../../controllers/UserService";
import AuthService from "../../controllers/AuthService";
import rData from "../../files/RiasecData.json";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);


const RiasecFormResult = props => {

  const { target, roomId, studentId } = useParams();
  const [fullName, setFullName] = useState('');
  const [assessor, setAssessor] = useState('STUDENT');
  const [chartData, setChartData] = useState(null);
  const [top1, setTop1] = useState('');
  const [top2A, setTop2A] = useState('');
  const [top2B, setTop2B] = useState('');
  const [skill, setSkill] = useState(null);
  const [schoolName, setSchoolName] = useState('');
  const [logo, setLogo] = useState('');
  const [pdfWidth, setPdfWidth] = useState('');
  const [showReadMe, setShowReadMe] = useState('');
  const [targetTHName, setTargetTHName] = useState('ผลประเมินจากตัวเอง');
  let studentName = "";
  let textRoom = "";

  const loadResult = (role = null) => {
    UserService.getRiasecResult(roomId, studentId, target.toUpperCase())
      .then((response) => {
        setChartData(null)
        setTop1('')
        setTop2A('')
        setTop2B('')
        setSkill(null)

        console.log(response);

        // TOP Data
        let res = null
        if (response.data && response.data.data && response.data.data[0]) {
          textRoom = response.data.data[0].room.displayName;
          res = response.data.data[0]
          const top = res.top
          if (top.top1.length > 0) {
            if (top.top1.length === 1) {
              setTop1(top.top1[0])
              if (top.top2.length > 0) {
                if (top.top2.length === 1) {
                  setTop2A(top.top2[0])
                } else if (top.top2.length === 2) {
                  setTop2A(top.top2[0])
                  setTop2B(top.top2[1])
                }
              }
            } else if (top.top1.length === 2) {
              setTop1(top.top1[0])
              setTop2A(top.top1[1])
            }
          }

          // Chart Js Data
          const percent = res.percent
          const total = res.total
          const chartValue = [
            percent.r,
            percent.i,
            percent.a,
            percent.s,
            percent.e,
            percent.c,
          ]
          const scoreValue = [
            total.r,
            total.i,
            total.a,
            total.s,
            total.e,
            total.c,
          ]
          setChartData({
            // labels: [`Realistic: ${scoreValue[0]} (${chartValue[0]}%)`, `Investigation: ${scoreValue[1]} (${chartValue[1]}%)`, `Artistic: ${scoreValue[2]} (${chartValue[2]}%)`, `Social: ${scoreValue[3]} (${chartValue[3]}%)`, `Enterprising: ${scoreValue[4]} (${chartValue[4]}%)`, `Convention: ${scoreValue[5]} (${chartValue[5]}%)`],
            labels: [`Realistic: ${chartValue[0]}%`, `Investigation: ${chartValue[1]}%`, `Artistic: ${chartValue[2]}%`, `Social: ${chartValue[3]}%`, `Enterprising: ${chartValue[4]}%`, `Convention: ${chartValue[5]}%`],
            datasets: [
              {
                label: 'ค่าคะแนน',
                data: chartValue,
                backgroundColor: 'rgba(98, 222, 170, 0.6)',
                borderColor: 'rgba(98, 222, 170, 1)',
                borderWidth: 2
              },
            ],
          })

          // Set Personality and Occupation Data
          let s = []
          if (top && top.top1Select && top.top1Select !== null) {
            if (top.top1Select.length >= 3) {
              top.top1Select = top.top1Select.substring(0,2);
            } 
            const t1S = rData.findIndex(x => x.riasec === top.top1Select);            
            if (t1S) {
              s.push(rData[t1S])
            }
          } else {
            if (top.top121Abb) {
              const t1 = rData.findIndex(x => x.riasec === top.top121Abb);
              if (t1) {
                s.push(rData[t1])
              }
            }
            if (top.top122Abb) {
              const t2 = rData.findIndex(x => x.riasec === top.top122Abb);
              if (t2) {
                s.push(rData[t2])
              }
            }
          }
          setSkill(s)

          // Set Condition show Readme
          let pdfW = '1250px'
          let SReadme = 'hide'
          if (top && top.top1Select && top.top1Select !== null) {
            pdfW = '1340px'
            SReadme = 'show'
          }
          setPdfWidth(pdfW)
          setShowReadMe(SReadme)

        }
      }).then(() => {

        setTimeout(() => {
          makePDF();
        }, 1000)
      })
  }

  useEffect(() => {
    try {
      UserService.getRoomDetail(roomId).then((response) => {
        if (response.data.data && response.data.data.domain) {
          setSchoolName(response.data.data.domain.displayName)
          //setLogo('/images/school/'+ response.data.data.domain.id + '_' +response.data.data.domain.name +'.png');
          setLogo(UserService.getLogoUrl());

        }
      }).then(() => {
        UserService.getUserById(studentId)
          .then((response) => {
            if (response.data.data && response.data.data.fullName) {
              setFullName(response.data.data.fullName)
              studentName = response.data.data.fullName;
            }
          }).then(() => {
            loadResult()
          })
      })
    } catch (error) {

    }

    if (target && target === 'teacher') {
      setTargetTHName('ผลประเมินจากครู')
    } else if (target && target === 'parent') {
      setTargetTHName('ผลประเมินจากผู้ปกครอง')
    }

  }, []);

  const makePDF = () => {

    const printArea = document.getElementById("riasec-pdf");
    html2canvas(printArea, {
      scale: 2,
      allowTaint: true, useCORS: true, logging: true
    }).then(async (canvas) => {
      const dataURL = canvas.toDataURL();

      const unit = "pt";
      const size = "A4"; // Use A1, A2, A3 or A4
      const orientation = "portrait"; // portrait or landscape

      const pdf = new jsPDF(orientation, unit, size);
      const w = 595
      const h = 843
      pdf.addImage(dataURL, 'JPEG', 0, 0, w, h);
      const safeStudentName = studentName.replace(/ /g, '_');
      const safeRoom = textRoom.replace(/ม.|ป.|\/| /g, '_');
      const role = target === 'parent' || target === 'teacher' ? target : 'student';
      // target ต้องเป็น parent | student | teacher
      const fileName = `${safeStudentName}_rf_room_${safeRoom}_${role}`;
      await pdf.save(fileName + '.pdf')
      setTimeout(() => { window.close(); }, 2000)
    })


  }

  return (
    <div>
      <div style={{ 'height': '100vh' }} class="text-center m-auto">
        <div class="loader">Loading...</div>
        <h2 style={{ "color": "#3765D1" }}>Loading...</h2>
      </div>
      {
        (pdfWidth) ? (
          <div id="riasec-pdf" className='riasec-result-page' style={{ 'width': pdfWidth }}>
            <Row>
              <Col xs={12} className='main-detail riasec-header text-center'>
                <Row className='pdf-header'>
                  <Col xs={8}>
                    <div className="d-flex mb-1">
                      <div className="d-flex" style={{ "width": "100px", "padding-right": "5px" }}>
                        <img src={logo} width={'100%'} className="m-auto" alt='' crossOrigin="true" />
                        {/* <img src='/images/riasec/test-school-logo.png' width={'100%'} className="m-auto" alt=''/> */}
                      </div>
                      <div className="d-flex">
                        <div className="m-auto">
                          <p className="font-sarabun-bold  m-0 text-left t-12 school-name">{schoolName}</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col xs={4} className='pdf-header-r'>
                    <img src='/images/riasec/export-qr-code.png' height={'120'} alt='what-riasec' />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className='main-detail riasec-header text-center'>
                <h1 className='headline1 primary-text mt-3'>{targetTHName}</h1>
                <h2 className='headline2'>RIASEC Statistics (Score)</h2>
                <h3 className='fullname primary-text font-sarabun-bold'>{fullName}</h3>
              </Col>
            </Row>

            {
              (chartData && skill) ? (
                <Row>
                  <Col xs={12} className='main-detail riasec-canvas3'>
                    <div className='d-inline-flex w-100'>
                      <Radar data={chartData}
                        options={{
                          plugins: {
                            legend: {
                              display: false
                            }
                          }, scales: {
                            r: {
                              pointLabels: {
                                font: {
                                  size: 16
                                }
                              },
                              max: 25,
                              min: 0,
                              ticks: {
                                stepSize: 5
                              }
                            }
                          }
                        }}
                        className='m-auto' />
                    </div>
                  </Col>
                  {
                    (showReadMe && showReadMe === 'show') ? (
                      <Col xs={12} className='pb-lg-5 px-5' style={{ 'width': '85%' }}>
                        <h2 className='font-sarabun-bold primary-text text-center mb-2 readme-bf mb-lg-4'>เราอยากให้อ่านก่อนที่จะดูผลลัพธ์ด้านล่าง</h2>
                        <span className='font-sarabun mb-3 t-18'>
                          ลองดูจากกราฟสิ จะเห็นว่าเราในตัวเธอมีความหลากหลายทั้งในบุคลิกภาพ ความชอบและความสนใจ แต่... ไม่ใช่เรื่องที่ผิดอะไรเลยนะ แถมเป็นเรื่องที่ดีด้วยซ้ำ
                          เพราะมันอาจจะเหมาะกับหลากหลายอาชีพที่น่าสนใจ เอาเป็นว่าสุดท้ายผลลัพธ์ของอาชีพที่เราเลือกมาจะไม่ได้เป็นตัวกำหนด แต่เราคิดว่ามันเหมาะกับเธอที่สุดในช่วงเวลานี้นะ เราไปดูผลลัพธ์ด้านล่างกันเลย!!
                        </span>
                      </Col>
                    ) : (
                      <span />
                    )}
                  <Col xs={12} className='main-detail most-skill py-3'>
                    <Row className=''>
                      <Col xs={4} className='text-center d-flex'>
                        <Row className='m-auto'>
                          <Col xs={12} className='position-relative'>
                            <img src='/images/riasec/result-circle.png' className='riasec-circle' width={'100%'} alt='circle' />
                            <div className={`r-${skill.length} result-circle-frame position-absolute d-flex`}>
                              <div className='m-auto result-circle-text'>
                                {
                                  (skill && skill.length > 0) ? (
                                    skill.map((item, index) => (
                                      <span>
                                        {
                                          (index > 0) ? (
                                            <br />
                                          ) : (
                                            <span />
                                          )
                                        }
                                        {item.riasec}
                                      </span>
                                    ))
                                  ) : (
                                    <span></span>
                                  )
                                }
                              </div>
                            </div>
                          </Col>
                          <Col xs={6} className='riasec-top'>
                            <div>
                              <img src='/images/riasec/top1.png' className='r-icon' alt='top1' />
                            </div>
                            <div className='top1 ml-4'>{top1}</div>
                          </Col>
                          <Col xs={6} className='riasec-top'>
                            <div>
                              <img src='/images/riasec/top2.png' className='r-icon' alt='top2' />
                            </div>
                            <div className='top2 ml-4'>{top2A}</div>
                            <div className='top2 ml-4'>{top2B}</div>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={8}>
                        <h1 className='headline font-sarabun-bold text-center'>Most Remarkable RIASEC Skills</h1>
                        <Row>
                          <Col xs={12} className='riasec-detail py-3'>
                            {
                              (skill && skill.length > 0) ? (
                                skill.map((item, index) => (
                                  <div className='pr-3'>
                                    {
                                      (skill && skill.length > 1) ? (
                                        <h3 >{item.riasec}</h3>
                                      ) : (
                                        <span></span>
                                      )
                                    }
                                    <span className='font-sarabun-bold'>
                                      {item.personality}
                                    </span>
                                  </div>
                                ))
                              ) : (
                                <div></div>
                              )
                            }
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} className='main-detail recommend-career'>
                    <div className='frame'>
                      <div className='detail'>
                        {
                          (skill && skill.length > 0) ? (
                            skill.map((item, index) => (
                              <div>
                                <h2 className='font-sarabun-bold primary-text text-center mt-2'>{item.riasec} - อาชีพที่อาจจะเป็นไปได้สำหรับบุคลิกภาพนี้</h2>
                                <span className='font-sarabun mb-3'>
                                  {item.occupation}
                                </span>
                              </div>
                            ))
                          ) : (
                            <div></div>
                          )
                        }
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <div className='no-result text-center font-sarabun-bold mt-4'>ยังไม่มีการประเมิน</div>
              )
            }
            <Row>
              <Col xs={12} className='main-detail riasec-footer text-center'>
                <span className='font-sarabun-bold'>ออกโดยบริษัท MINDSET MAKER CO.,LTD.</span>
              </Col>
            </Row>
          </div>
        ) : (
          <div />
        )
      }

    </div>
  )
}


export default RiasecFormResult